var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasiccharts47(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 64,
    viewBox: "0 0 102 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8818_199121)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 60,
    y: 2,
    fill: "#D3DBE3",
    className: "template-background"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    width: 40,
    height: 18,
    rx: 2,
    fill: "#939BA7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 42,
    width: 40,
    height: 18,
    rx: 2,
    fill: "#939BA7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 19,
    height: 16,
    rx: 2,
    fill: "#939BA7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 4,
    width: 19,
    height: 16,
    rx: 2,
    fill: "#939BA7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 4,
    width: 2,
    height: 56,
    rx: 1,
    fill: "#5F6877",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 6,
    width: 2,
    height: 20.4444,
    rx: 1,
    fill: "#707987"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8818_199121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 60,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasiccharts47);
export default __webpack_public_path__ + "static/media/Basic charts-47.3d93cb4dbd56505b370a207b7086dfde.svg";
export { ForwardRef as ReactComponent };